import axios from "axios";
import { newAbortSignal } from "../../utils";
import { SessionStore } from "../../types/store/SessionStore";
import { UpdateUserRequest, User } from "../../types/interfaces/user";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/account`;

export const updateUser = async (
  accountId: number,
  userId: number,
  userData: UpdateUserRequest,
): Promise<User> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const finalURL = BASE_URL + "/" + accountId + "/user/" + userId;

  return await axios
    .put<User>(finalURL, userData, {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(
              Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
            )
          : AbortSignal.timeout(
              Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
            ),
    })
    .then((response) => response.data);
};
